var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-check",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.828125, 2.468750)",
    fill: "#212529",
    fillRule: "nonzero",
    id: "\\uF00C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.796875,0.125 C12.9635417,-0.0416666667 13.140625,-0.0416666667 13.328125,0.125 L14.203125,1.03125 C14.390625,1.19791667 14.390625,1.375 14.203125,1.5625 L4.828125,10.9375 C4.66145833,11.1041667 4.484375,11.1041667 4.296875,10.9375 L0.140625,6.75 C-0.046875,6.58333333 -0.046875,6.40625 0.140625,6.21875 L1.015625,5.34375 C1.203125,5.15625 1.38020833,5.15625 1.546875,5.34375 L4.578125,8.375 L12.796875,0.125 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.5ee35045d6baa52ba888bd4180078d9e.svg";
export { ForwardRef as ReactComponent };